module.exports = __webpack_public_path__ + "img/blob2.749cda36.svg";